import { useEffect, useRef } from "react";

const activeSections = new Set();
const sync = () =>
  document.body.classList.toggle("theme-dark", activeSections.size > 0);

export const ThemeDark = ({ children }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) activeSections.add(el);
        else activeSections.delete(el);
        sync();
      },
      { rootMargin: "-72% 0px -8% 0px", threshold: 0 }
    );
    observer.observe(el);
    return () => {
      observer.disconnect();
      activeSections.delete(el);
      sync();
    };
  }, []);

  return <div ref={ref}>{children}</div>;
};
